module.exports = __webpack_public_path__ + "media/images/landing/lake_charles_banner-ac61aca047bcb5dcfc05a2c61a58abfb.jpg";